module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "z-properties-log can-scroll"
  }, [(_vm.logs && Object.keys(_vm.logs).length) ? _c('div', {
    staticClass: "z-properties-log__list"
  }, _vm._l((_vm.logs), function(item) {
    return _c('div', {
      key: ("z-properties-log-item-" + (item.id)),
      staticClass: "z-properties-log__item"
    }, [(item.description) ? _c('div', {
      staticClass: "z-properties-log__item-body"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    })]) : _vm._e(), _vm._v(" "), (item.created_at) ? _c('div', {
      staticClass: "z-properties-log__item-footer"
    }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm.moment.tz(item.created_at, _vm.$root.defaultTimezone).fromNow() +
      ' (' + _vm.moment(item.created_at).tz(_vm.$root.userTimezone).format('HH:mm:ss DD.MM.YYYY') + ')') + "\n                ")])]) : _vm._e()])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b659e054","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZModulePropertiesLogs.vue
// module id = 1244
// module chunks = 0